// Load styles
import "../styles/index.scss";

import "./script.js";
import "./currency.js";
import "./overlay.js";
import "./file.js";
import "./customSelect.js";
import "./cookies.js";
import "./favourites.js";
import "./gallery.js";
import "./form.js";
import "./exclusive.js";
import "./aos.js";
import "./dropkick.js";
import "./splidejs.js";
